/* eslint-disable */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import SortingArrow from 'components/SortingArrow'
import sortDirection from 'constants/sortDirection'
import OptionIcon from 'assets/icons/options-icon'
import ExternalLinkIcon from 'assets/icons/external-link-icon'
import { ecoBioRegionRestricted } from 'constants/ecoBioRegionRestricted'
import capitalize from 'utils/capitalize'
import capitalizeFirstLetterString from 'utils/capitalizeFirstLetter'
import { specieAssessmentParameterType } from 'constants/speciesParameterType'

import { ReportsFactsheetIconWrapper, ReportsFactsheetWrapper, ReportsIucnStatusWrapper } from '../style'
import { SortingArrowWrapper } from 'components/SortingArrow/style'
import {renderSitesStatusIcon} from '../../SitesManagement/sitesTable'
import { getStickyTableColumnsLength } from 'utils/getStickyTableColumnsLength'


export const renderReportsIucnStatusIcon = (status) => {
  const color = {
    EX: '#FFFFFF',
    EW: 'rgba(84, 35, 68, 0.3)',
    CR: 'rgba(216, 30, 5, 0.5)',
    EN: 'rgba(252, 127, 63, 0.6)',
    VU: 'rgba(249, 232, 20, 0.6)',
    LR: 'rgba(226, 211, 105, 0.8)',
    NT: 'rgba(204, 226, 38, 0.6)',
    LC: 'rgba(96, 198, 89, 0.6)',
    DD: '#D1D1C6'
  }

  return (
    <ReportsIucnStatusWrapper color={color[status]}>
      <FormattedMessage id={status} />
    </ReportsIucnStatusWrapper>
  )
}

export const makeSpeciesTabRow = (speciesTableData) => {
  return speciesTableData.map((item) => {
    const siteStatus = item.kbaStatus
    let ecoBioRegionName = item.eco_bio_restricted
    if (!ecoBioRegionName && item.EcoBioRegionRestrictedId) {
      const ecoBioRegion = ecoBioRegionRestricted.find((ecoBioId) => {
        return ecoBioId.id === item.EcoBioRegionRestrictedId
      })
      ecoBioRegionName = ecoBioRegion ? capitalize(ecoBioRegion.name) : '-'
    }
    const assessmentParameter = specieAssessmentParameterType.find((paramId) => {
      return paramId.id === item.SiteAssesmentParameterTypeId || paramId.id === item.SiteAssessmentParameterTypeId
    })
    const paramName = assessmentParameter
      ? capitalize(assessmentParameter.name)
      : (typeof item.SiteAssesmentParameterTypeId === 'string' && item.SiteAssesmentParameterTypeId
          ? capitalize(item.SiteAssesmentParameterTypeId)
          : (item.parameter || '-'))

    const formatBool = (val) => {
      if (val === true || val === 'Yes') return 'Yes'
      if (val === false || val === 'No') return 'No'
      return '-'
    }

    const formatNumber = (val) => {
      if (val === null || val === undefined || val === '') return '-'
      if (typeof val === 'number') {
        return Number.isInteger(val) ? val.toString() : val.toFixed(2)
      }
      return val
    }

    return {
      siteCode: item.siteCode || item.SiteId || '-',
      region: Array.isArray(item.region) ? item.region.join(', ') : (item.region || '-'),
      country: Array.isArray(item.country) ? item.country.join(', ') : (item.country || '-'),
      siteName: item.siteName || '-',
      year: item.year != null ? item.year : '-',
      SiteStatusId: (
        <>
          {renderSitesStatusIcon(siteStatus)}
          {capitalize(siteStatus)}
        </>
      ),
      kbaClassification: item.kbaClassification || '-',
      taxonomicGroup: item.taxonomicGroup || '-',
      scientificName: item.scientificName || '-',
      commonName: item.specieName ? capitalizeFirstLetterString(item.specieName) : (item.commonName ? capitalizeFirstLetterString(item.commonName) : '-'),
      iucnStatus: item.RedListCategoryCode ? renderReportsIucnStatusIcon(item.RedListCategoryCode) : (item.iucnStatus ? renderReportsIucnStatusIcon(item.iucnStatus) : '-'),
      globallySensitive: formatBool(item.sensitiveSpecies != null ? item.sensitiveSpecies : item.globallySensitive),
      sensitiveInSite: formatBool(item.sensitive_site != null ? item.sensitive_site : (item.sensitive_at_site != null ? item.sensitive_at_site : item.sensitiveInSite)),
      redListCrit: item.IUCNRedListCriteria || item.redListCrit || '-',
      restrictedRangeStatus: formatBool(item.rangeRestricted != null ? item.rangeRestricted : item.restrictedRangeStatus),
      ecoregionBioregionRestricted: ecoBioRegionName || '-',
      legacySpecies: formatBool(item.legacySpecies != null ? item.legacySpecies : item.LegacySpecies),
      qualifyingSpecies: formatBool(item.qualifyingSpecies),
      parameter: paramName,
      bestGlobalEstimate: item.bestGlobal != null ? item.bestGlobal : (item.bestGlobalEstimate != null ? item.bestGlobalEstimate : '-'),
      siteEstimate: item.bestSite != null ? item.bestSite : (item.siteEstimate != null ? item.siteEstimate : '-'),
      percentInSite: formatNumber(item.percentInSite),
      yearOfSiteData: item.yearOfSiteData || item.earliestDataSetYear || item.earliestYear || '-',
      reproductiveUnits: item.minReproductiveUnits != null ? item.minReproductiveUnits : (item.reproductiveUnits != null ? item.reproductiveUnits : '-'),
      SpeciesCriteriaTriggered: Array.isArray(item.kbaCriterias) ? item.kbaCriterias.join(', ') : (item.kbaCriterias || item.SpeciesCriteriaTriggered || '-'),
      options: <ReportsFactsheetWrapper>
        <ReportsFactsheetIconWrapper>
          <ExternalLinkIcon />
        </ReportsFactsheetIconWrapper>
        <ReportsFactsheetIconWrapper>
          <OptionIcon />
        </ReportsFactsheetIconWrapper>
      </ReportsFactsheetWrapper>
    }
  })
}

export const makeSpeciesTabColumns = (sorting, setSorting, rows) => {
  const sortFunction = (sortBy) => {
    if (sorting.sortBy === sortBy) {
      if (sorting.sortDirection === sortDirection.ASC) {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.DESC })
      } else {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
      }
    } else {
      setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
    }
  }

  const sortBySiteID = () => {
    sortFunction('siteCode')
  }

  const sortBySiteCountry = () => {
    sortFunction('SiteDetailsCountryId')
  }

  const sortBySiteNameEnglish = () => {
    sortFunction('name')
  }

  const sortBySiteAssessmentYear = () => {
    sortFunction('year')
  }

  const sortBySiteStatus = () => {
    sortFunction('SiteStatusId')
  }

  const sortBySiteTaxonomicGroup = () => {
    sortFunction('taxonomicGroup')
  }

  const sortBySiteScientificName = () => {
    sortFunction('scientificName')
  }

  const sortBySiteName = () => {
    sortFunction('specieName')
  }

  const sortByIucnRedListCategory = () => {
    sortFunction('RedListCategoryCode')
  }

  const sortByIucnRedListCriteria = () => {
    sortFunction('IUCNRedListCriteria')
  }

  const sortByRestrictedStatus = () => {
    sortFunction('rangeRestricted')
  }

  const sortByEcoBioRestricted = () => {
    sortFunction('EcoBioRegionRestrictedId')
  }

  const sortByAssessmentParameter = () => {
    sortFunction('SiteAssesmentParameterTypeId')
  }

  const sortByBestGlobal = () => {
    sortFunction('bestGlobal')
  }

  const sortByBestSite = () => {
    sortFunction('bestSite')
  }

  const sortByEarliestDataSetYear = () => {
    sortFunction('earliestDataSetYear')
  }

  const sortByReproductiveUnits = () => {
    sortFunction('minReproductiveUnits')
  }

  return [
    {
      id: 'siteCode',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteId' />
          <SortingArrow
            onChange={sortBySiteID}
            checked={sorting.sortBy === 'siteCode' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteCode',
      width: 100,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'region',
      header: (
        <>
          <FormattedMessage id='region' />
        </>
      ),
      accessorKey: 'region',
      width: getStickyTableColumnsLength('region', rows),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'country',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='countryLabel' />
          <SortingArrow
            onChange={sortBySiteCountry}
            checked={sorting.sortBy === 'SiteDetailsCountryId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'country',
      width: getStickyTableColumnsLength('country', rows, 150, true),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteName',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteNameEng' />
          <SortingArrow
            onChange={sortBySiteNameEnglish}
            checked={sorting.sortBy === 'name' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteName',
      width: getStickyTableColumnsLength('siteName', rows, 200),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'year',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='yearOfAssessment' />
          <SortingArrow
            onChange={sortBySiteAssessmentYear}
            checked={sorting.sortBy === 'year' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'year',
      width: getStickyTableColumnsLength('year', rows, 140),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'SiteStatusId',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='kbaStatus' />
          <SortingArrow
            onChange={sortBySiteStatus}
            checked={sorting.sortBy === 'SiteStatusId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'SiteStatusId',
      width: 180,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'kbaClassification',
      header: (
        <>
          <FormattedMessage id='kbaClassification' />
        </>
      ),
      accessorKey: 'kbaClassification',
      width: getStickyTableColumnsLength('kbaClassification', rows, 175),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'taxonomicGroup',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='taxonomicGroup' />
          <SortingArrow
            onChange={sortBySiteTaxonomicGroup}
            checked={sorting.sortBy === 'taxonomicGroup' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'taxonomicGroup',
      width: getStickyTableColumnsLength('taxonomicGroup', rows, 180),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'scientificName',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='scientificName' />
          <SortingArrow
            onChange={sortBySiteScientificName}
            checked={sorting.sortBy === 'scientificName' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'scientificName',
      width: getStickyTableColumnsLength('scientificName', rows, 166),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'commonName',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='commonName' />
          <SortingArrow
            onChange={sortBySiteName}
            checked={sorting.sortBy === 'specieName' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'commonName',
      width: getStickyTableColumnsLength('commonName', rows, 166),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'iucnStatus',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='iucnStatus' />
          <SortingArrow
            onChange={sortByIucnRedListCategory}
            checked={sorting.sortBy === 'RedListCategoryCode' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'iucnStatus',
      width: 155,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'globallySensitive',
      header: (
        <>
          <FormattedMessage id='globallySensitive' />
        </>
      ),
      accessorKey: 'globallySensitive',
      width: getStickyTableColumnsLength('globallySensitive', rows, 140),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'sensitiveInSite',
      header: (
        <>
          <FormattedMessage id='sensitiveInSite' />
        </>
      ),
      accessorKey: 'sensitiveInSite',
      width: getStickyTableColumnsLength('sensitiveInSite', rows, 140),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'redListCrit',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='redListCrit' />
          <SortingArrow
            onChange={sortByIucnRedListCriteria}
            checked={sorting.sortBy === 'IUCNRedListCriteria' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'redListCrit',
      width: getStickyTableColumnsLength('redListCrit', rows, 160),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'restrictedRangeStatus',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='restrictedRangeStatus' />
          <SortingArrow
            onChange={sortByRestrictedStatus}
            checked={sorting.sortBy === 'rangeRestricted' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'restrictedRangeStatus',
      width: 195,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'ecoregionBioregionRestricted',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='ecoregionBioregionRestricted' />
          <SortingArrow
            onChange={sortByEcoBioRestricted}
            checked={sorting.sortBy === 'EcoBioRegionRestrictedId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'ecoregionBioregionRestricted',
      width: 275,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'legacySpecies',
      header: (
        <>
          <FormattedMessage id='legacySpecies' />
        </>
      ),
      accessorKey: 'legacySpecies',
      width: getStickyTableColumnsLength('legacySpecies', rows, 180),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'qualifyingSpecies',
      header: (
        <>
          <FormattedMessage id='qualifyingSpecies' />
        </>
      ),
      accessorKey: 'qualifyingSpecies',
      width: getStickyTableColumnsLength('qualifyingSpecies', rows, 140),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'parameter',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='parameter' />
          <SortingArrow
            onChange={sortByAssessmentParameter}
            checked={sorting.sortBy === 'SiteAssesmentParameterTypeId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'parameter',
      width: 240,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'bestGlobalEstimate',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='bestGlobalEstimate' />
          <SortingArrow
            onChange={sortByBestGlobal}
            checked={sorting.sortBy === 'bestGlobal' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'bestGlobalEstimate',
      width: getStickyTableColumnsLength('bestGlobal', rows, 197),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteEstimate',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteEstimate' />
          <SortingArrow
            onChange={sortByBestSite}
            checked={sorting.sortBy === 'bestSite' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteEstimate',
      width: getStickyTableColumnsLength('bestSite', rows, 185),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'percentInSite',
      header: (
        <>
          <FormattedMessage id='percentInSite' />
        </>
      ),
      accessorKey: 'percentInSite',
      width: getStickyTableColumnsLength('percentInSite', rows, 130),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'yearOfSiteData',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='yearOfSiteData' />
          <SortingArrow
            onChange={sortByEarliestDataSetYear}
            checked={sorting.sortBy === 'earliestDataSetYear' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'yearOfSiteData',
      width: getStickyTableColumnsLength('yearOfSiteData', rows, 160),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'reproductiveUnits',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='reproductiveUnits' />
          <SortingArrow
            onChange={sortByReproductiveUnits}
            checked={sorting.sortBy === 'minReproductiveUnits' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'reproductiveUnits',
      width: getStickyTableColumnsLength('minReproductiveUnits', rows, 140),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'SpeciesCriteriaTriggered',
      header: (
        <>
          <FormattedMessage id='SpeciesCriteriaTriggered' />
        </>
      ),
      accessorKey: 'SpeciesCriteriaTriggered',
      width: getStickyTableColumnsLength('SpeciesCriteriaTriggered', rows, 190),
      cell: ({ getValue }) => getValue()
    }
  ]
}
